import { PageHeaderConfig } from "@ui/context/component-config-context";

const pageHeaderConfig: PageHeaderConfig = {
  borderBottom: false,
  borderTop: false,
  center: false,
  className: "",
  classNameDescription: "",
  classNameLinks: "",
  classNameSubhead: "",
  classNameTitle: "",
  headingLevel: "h1",
  isBranded: false,
  moreLinkIcon: null,
  paddingBottom: false,
  size: "small",
  title: "",
  componentContext: {
    categoryPillar: {
      size: "large",
    },
    latestRecirc: {
      size: "medium",
    },
    spotlightSection: {
      size: "medium",
      borderTop: "standard",
    },
    articleParentRecirc: {
      borderTop: "standard",
    },
    standardRail: {
      title: "Most Popular",
    },
    newsletterPage: {
      borderBottom: true,
    },
  },
};

export default pageHeaderConfig;
